<template>
  <div>
    <v-card>
      <v-card-title class="my-1 py-1">
        <div>لیست {{ categoryTypeDisplayName }}</div>
         <v-divider></v-divider>
        <v-btn
          :disabled="addNewBtnDisabled"
          class="mx-1 float-left"
          color="primary"
          @click.stop="openCreateOrEditDialog()"
        >
          <v-icon>mdi-plus</v-icon> ایجاد شناسنامه(کاتالوگ) در حوزه :
          <span style="font-weight: 700; color: yellow">
            {{ categoryTypeDisplayName }}</span
          >
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="my-0 py-0">
        <v-row class="my-0 py-0">
          <strong class="ml-2">
            در این بخش کالا و خدمات خود را ثبت و مدیریت کنید.</strong
          >
          <HelperComponent helperId="how-to-manage-your-product-service" />
        </v-row>
      </v-card-subtitle>
      <v-divider> </v-divider>
      <v-card-text>
        <supplier-products-list
          :categoryType="supplierProductType"
          :categoryTypeDisplayName="categoryTypeDisplayName"
        >
        </supplier-products-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
//We Have 4 Action in SupplierProduct Management
// 1- Adding New SupplierProduct Without using Base Product, we call it "NewProdNoBase"
// 2- Editing Previouse Added if it does not Used bu Other Supplier as base product, we call it "EditProdNoBase"
// 3= Adding New SupplierProduct by using Base Product, we call it "NewProdByBase"
// 4- Editing no 3 in every statuse ( confirmed by Admin or not), we call it "EditProdByBase"
// We will have Variable ActionName by flowwing
// 1: "NewProdNoBase"
// 2: "EditProdNoBase"
// 3: "NewProdByBase"
// 4: "EditProdByBase"
// 5: "addNew" general add new(1 or 3)
// All prod means SupplierProduct equal SupplierProduct Model
// Base means The Product Model On Backend
import SupplierProductsList from '../components/SupplierProductsList.vue';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  components: {
    SupplierProductsList,
  },
  data() {
    return {
      categoryTypeItemsList: [],
      categoryTypeDisplayName: null,
      addNewBtnDisabled: false,
    };
  },
  created() {
    this.getCategoryTypeItemsList();
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    supplierProductType() {
      return this.$route.params.supplierProductType;
    },
  },
  watch: {
    supplierProductType(after, before) {
      if (after) {
        this.getCategoryTypeLabel(after);
      }
    },
  },
  methods: {
    // May be Should Cjange Function Name to openCreateDialog()
    openCreateOrEditDialog() {
      this.addNewBtnDisabled = true;
      this.$store.commit('setSupplierProductFormStatus', true);
      //There we don't know which kind of Add new will be used, we determine it in Sp newFprm
      this.$router.push({
        path: `/supplier-products/${this.supplierProductType}/form/addNew`,
      });
      setTimeout(() => {
        this.addNewBtnDisabled = false;
      }, 1000);
    },
    getCategoryTypeItemsList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.productBaseUrl)
        .then(({ data }) => {
          this.categoryTypeItemsList = data;
          this.getCategoryTypeLabel(this.supplierProductType);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getCategoryTypeLabel(categoryType) {
      if (this.categoryTypeItemsList.length) {
        let result = null;
        result = this.categoryTypeItemsList.find(
          (el) => el.title == categoryType
        );
        this.categoryTypeDisplayName = result ? result.displayName : result;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
